var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVertRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8.6 266.5",
    style: {
      enableBackground: "new 0 0 8.6 266.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DE3823;}\n\t.st1{fill:#9CB6B7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000016792960537037345330000005639569681634217088_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03.Dotted-lines"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 8.6,
    height: 266.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.6,266.5H0.1v-12h8.5V266.5z M8.6,242.5H0.1v-12h8.5V242.5z M8.6,218.5H0.1v-12h8.5V218.5z M8.6,194.4H0.1 v-12h8.5V194.4z M8.6,170.4H0.1v-12h8.5V170.4z M8.6,146.4H0.1v-12h8.5V146.4z M8.6,122.4H0.1v-12h8.5V122.4z M8.6,98.4H0.1v-12 h8.5V98.4z M8.6,74.4H0.1v-12h8.5V74.4z M8.6,50.4H0.1v-12h8.5V50.4z M8.6,26.4H0.1v-12h8.5V26.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertRed);
export default __webpack_public_path__ + "static/media/vertRed.93e3e503df7ed3cdddf13cdabb1b8a56.svg";
export { ForwardRef as ReactComponent };